module.exports = __webpack_public_path__ + "img/dance-school-icon6.2413b6fa.png";